<form id="dialogContainer" class="flex flex-col w-full h-full" [formGroup]="bulkActionForm">

  <div mat-dialog-title>
    <div id="titleIconContainer" class="flex flex-row justify-center items-center">
      <mat-icon svgIcon="update_in_gmb"></mat-icon>
    </div>
    <div id="titleTextContainer" class="flex flex-row justify-center items-center">
      <h1>Update in GBP</h1>
    </div>
  </div>

  <mat-dialog-content id="dialogContent" class="flex flex-row">
    <div id="stickyLeftPanel">
      <div class="flex flex-col mx-2">
        <div class="flex flex-row">
          <span class="selectionNumber">{{data.selectedLocationsCount
          + (data.selectedLocationsCount === 1 ? " location " : " locations ") + "selected"}}</span>
        </div>

        <!-- Field selection -->
        <div id="fieldSelection" class="flex flex-col mt-[12px]">
          <p class="selectionLabel">Fields</p>

          <mat-radio-group id="fieldSelectionRadioGroup"
            class="flex flex-col"
            name="fieldSelectionRadioGroup"
            formControlName="selectedFieldsRadio">
            @for (radio of selectedFieldsRadios; track radio) {
              <mat-radio-button class="radioButton"
                [name]="radio"
                [value]="radio">
                <span class="cursor-pointer">{{ radio }}</span>
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      </div>
    </div>

    <!-- Checkboxes -->
    <div class="flex flex-row" formArrayName="selectedFields">

      @for (column of columns; let first = $first; let last = $last; track column) {
        <div class="flex flex-col"
             [ngClass]="{ 'mr-2': !last,
                          'ml-2': first }">
          @for (group of column; track group; let i = $index) {
            <div class="fieldGroupContainer"
                 [ngClass]="{ 'mt-2': i>=1 }">
              <!-- Master checkbox -->
              <mat-checkbox class="fieldGroupCheckbox"
                (change)="toggleFieldGroup(getFieldIDsByGroup(group))"
                [checked]="allFieldsChecked(getFieldIDsByGroup(group))"
                          [indeterminate]="!allFieldsChecked(getFieldIDsByGroup(group))
                              && someFieldsChecked(getFieldIDsByGroup(group))">
                {{ group }}
              </mat-checkbox>
              <!-- Checkboxes of a field group -->
              <div class="flex flex-col ml-[32px]">
                @for (fieldID of getFieldIDsByGroup(group); track fieldID) {
                  <mat-checkbox
                    name="{{ getFieldNameByFieldID(fieldID) }}"
                    [formControlName]="getSelectableFieldIndexByFieldID(fieldID)">
                    <span>{{ getFieldNameByFieldID(fieldID) }}</span>
                  </mat-checkbox>
                }
              </div>
            </div>
          }
        </div>
      }

    </div>
  </mat-dialog-content>

  <mat-dialog-actions id="actionBar"
    align="end">
    <button matButton="outlined"
      id="cancelButton"
      [mat-dialog-close]="null">{{'CANCEL' | translate}}
    </button>
    <button mat-flat-button color="primary"
      id="confirmButton"
      [disabled]="!areFieldsSelected()"
      [mat-dialog-close]="generateResult()">Update in GBP
    </button>
  </mat-dialog-actions>

</form>
